export * from "/__w/wiggot-web/wiggot-web/packages/web-components/components/switch-v2/SwitchV2.tsx"